import React, {Component} from 'react';
import { Form, Row, Col} from 'react-bootstrap';
import * as constant from '../../Constant';
import SelectSearch, { fuzzySearch }  from 'react-select-search';
import './CurrentProduct.css';
import '../../styles/SelectSearch.css';
import '../../styles/Common.css';
import AutoComplete from '../AutoComplete/AutoComplete';

class CurrentProduct extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentProduct: [],
            showSerialNumberCheck: false,
            productToSwap :"",
            selecteResolutionCode:"",
            selectedProductId:"",
            fromComponentDidMount:false,
            manualSerialNumber:"",
            errorMessage:"",
            valid: true
        }
        this.onSelectProduct = this.onSelectProduct.bind(this);
        this.onAssetIdSelected = this.onAssetIdSelected.bind(this);
      }
    

    onSelectProduct(event) {
        this.setState({productToSwap:event.target.value});
        this.setState({showSerialNumberCheck: false});
        this.props.productToSwap(event.target.value);
        this.setState({selectedProductId: ""});
        this.props.assetIdProductToSwap("");
        this.setState({ manualSerialNumber: "" });
        this.props.assetManuallyEntered("");
        this.setState({errorMessage: ""});
   }

   onAssetSelected(event) {
        this.props.assetIdProductToSwap(event.target.value);
   }

   onAssetIdSelected(event){
       if(event != null){
        this.setState({selectedProductId: event});
        this.props.assetIdProductToSwap(event);
       } 

       if(typeof event === "object") {
        this.setState({selectedProductId: ""});
        this.props.assetIdProductToSwap("");
       }
   }

   onManualSerialNumber(event) {
    const value = event.target.value.toUpperCase();
    const regex = /^[0-9a-zA-Z]+$/; //this will admit letters and numbers
    if (value.length > 4) {
        this.state.currentProduct.every(item => {
            if (item.productCount > 0) {
                item.serialNumber.every(product => {
                    if (product.serialNumber.toUpperCase() === value){
                        this.setState({errorMessage: "Please check the Serial # entered. "+ value +" is associated with a "+item.displayName+" for this address."});
                        return false;
                    } else {
                        this.setState({errorMessage: ""});
                    }
                });
            }
        });
    } else {
        this.setState({errorMessage: ""});
    }

    if (value.match(regex) || value === "") {
      this.setState({ manualSerialNumber: value });
      this.setState({selectedProductId: ""});
      this.props.assetIdProductToSwap("");
      this.props.assetManuallyEntered(value);
    }
   }

   onShowSerialNumberCheck(event) {
        this.setState({showSerialNumberCheck: event.target.checked});
        this.setState({selectedProductId: ""});
      //  if(!event.target.checked) {
            this.props.assetIdProductToSwap("");
            this.props.assetManuallyEntered("");
            this.setState({ manualSerialNumber: "" });
     //   }
   }

    componentDidMount() {
        this.setState({currentProduct: this.props.productList});
        this.setState({valid: this.props.isValid});
        if(this.props.selectedResolution === constant.SWAP_120L) {
            for (var i = 1; i <= this.props.productList.length; i++) {
                if (!this.props.productList[this.props.productList.length - i].productName.toLowerCase().includes('organic')) {
                    this.setState({productToSwap: this.props.productList[this.props.productList.length - i].productCode});
                    break;
                }
            }
        } else if(this.props.selectedResolution === constant.SWAP_240L){ 
            for (var j = 0; j < this.props.productList.length; j++) {
                if (!this.props.productList[j].productName.toLowerCase().includes('organic')) {
                    this.setState({productToSwap: this.props.productList[j].productCode});
                    break;
                }
            }

        } else {
            if (this.props.productList.length > 0) {
                this.setState({productToSwap: this.props.productList[0].productCode});
            } else {
                this.setState({productToSwap: constant.ORGANICS_120L});
            }
            
        }
    }

    componentDidUpdate(prevProps){
    
        var flagFirstSelection ;
        if(this.props !== prevProps) {
            this.setState({valid: this.props.isValid});
        }

        if(document.querySelector('select[name = "select-asset"]') !== null && this.state.selectedProductId !== document.querySelector('select[name = "select-asset"]').value){
            this.setState({selectedProductId: document.querySelector('select[name = "select-asset"]').value});
            this.props.assetIdProductToSwap(document.querySelector('select[name = "select-asset"]').value);
        } 

       if((this.props.resolutionUserSelectedFromDropDown && this.props !== prevProps)) {
        if ((this.props.selectedProductToSwap !== this.state.productToSwap || this.props.selectedResolution !== this.state.selecteResolutionCode) && !this.props.selectedResolution.substring(0,3).toLowerCase().includes("rpc")) {
           this.setState({showSerialNumberCheck: false});
           this.setState({selectedProductId: ""});
           this.props.assetIdProductToSwap("");
        }
            if(this.props.selectedResolution === constant.SWAP_120L){
                this.setState({showSerialNumberCheck: false});
                 this.setState({selecteResolutionCode: this.props.selectedResolution});    
                 this.selectSwapBigSize();
            } else if(this.props.selectedResolution === constant.SWAP_240L){
                this.setState({showSerialNumberCheck: false});
                 this.setState({selecteResolutionCode: this.props.selectedResolution});       
                 this.selectSwapSmallSize();
            } else {
                this.setState({selecteResolutionCode: this.props.selectedResolution}, () => {
                    if(!flagFirstSelection) {
                        if(this.props.selectedResolution !== prevProps.selectedResolution) {
                            this.setState({showSerialNumberCheck: false});
                        } 
                    } else {
                        flagFirstSelection = false;
                    }
                });

                // if(flagFirstSelection) {
                //     if((this.props.selectedResolution != this.state.selecteResolutionCode)  && prevProps.selectedResolution != "") {
                //         this.setState({showSerialNumberCheck: false});
                //     } else {
                //         flagFirstSelection = false;
                //     }
                // }
                this.selectSwapSmallSize();
                
            }
        } else {
            flagFirstSelection = true;
        }
    }

    selectSwapBigSize(){
            var selectedElement = document.getElementsByName("available-product");
            if (this.props.selectedProductToSwap !== selectedElement[selectedElement.length - 1].value){
                selectedElement[selectedElement.length - 1].checked = true;
                this.setState({productToSwap: selectedElement[selectedElement.length - 1].value});
                this.props.productToSwap(selectedElement[selectedElement.length - 1].value);
            }
    }

    selectSwapSmallSize(){
            var selectedElement = document.getElementsByName("available-product");
            if (this.props.selectedProductToSwap !== selectedElement[0].value){
                selectedElement[0].checked = true;
                this.setState({productToSwap: selectedElement[0].value});
                this.props.productToSwap(selectedElement[0].value);
            }
    }

    onCheckProductChanged = (event) => {
        this.setState({showSerialNumberCheck: event.target.value});
    }


    render() {

    var options = [];

    // {item.serialNumber.map(item => {
    //     options.push({value :item.assetId, name :item.serialNumber});
    // })} 

     var products = this.state.currentProduct.map(item =>(
        <div key = {item.productName} className="product-margin-top">
            { 
                (this.props.selectedResolution.toLowerCase().includes("swp") && item.productCount > 0) ? 
                    (!item.productName.toLowerCase().includes("organic")) ? [ (<Row key = "row-product-list">
                        <Col>
                            <Form.Check 
                                    key ={item.productName}
                                    type="radio"
                                    label= {item.displayName}
                                    value = {item.productCode}
                                    checked={item.productCode === this.state.productToSwap}
                                    onChange={this.onSelectProduct}
                                    name= "available-product"/>
                        </Col>
                    </Row>),
                    (this.state.productToSwap === item.productCode ? 
                        <div  key = {item.productName} className ="product-details">
                        {/* <Row>
                            <Col>
                                <Form.Check 
                                                key ={item.productName}
                                                type="checkbox"
                                                defaultValue= {false}
                                                label= "Need us to service a specific cart? Select the serial number of the specific cart you would like serviced."
                                                checked={this.state.showSerialNumberCheck}
                                                onChange = {(event) => this.onShowSerialNumberCheck(event)}
                                                name= "check-available-product"/>
                            </Col>
                        </Row> */}
            
                        <Row className="serial-number-margin-top">
                            <Col> 
                                {/* {this.state.showSerialNumberCheck ?  
                                    
                                // <Form.Control as="select" name="select-asset" key = {item.productName} className="select-down-arrow" onChange={(event)=>this.onAssetIdSelected(event.target.value)}>
                                //     {item.serialNumber.map(item => {
                                //     return <option key = {item.assetId} value={item.assetId}>{item.serialNumber}</option>
                                //     })}
                                
                                // </Form.Control> ]
                                    */}
                                <div> 
                                    { item.serialNumber.forEach(item => {
                                        options.push({value :item.assetId, name :item.serialNumber});
                                    })
                                    }
                                {/* <SelectSearch
                                        options={options}
                                        search
                                        emptyMessage="Not found"
                                        onChange={(event)=>this.onAssetIdSelected(event)}
                                        filterOptions={fuzzySearch}
                                        placeholder="Select"
                                /> */}
                                 <AutoComplete className={(!this.state.valid && this.state.selectedProductId.length === 0)? "invalid-border": ""} isValid={this.state.valid} suggestions= {options} onAssetIdSelected ={this.onAssetIdSelected}/>

                                </div>
                            
                                <br/>
                            </Col>
                        </Row></div> : null )
                    ] : null  
            : [ this.props.selectedResolution.substring(0,3).toLowerCase().includes("rpc") ? 
               [ 
                   (<Row key = "row-product-list">
                    <Col>
                        <Form.Check 
                                key ={item.productName}
                                type="radio"
                                label= {item.displayName}
                                value = {item.productCode}
                                checked={item.productCode === this.state.productToSwap}
                                onChange={(event) => this.onSelectProduct(event)}
                                name= "available-product"/>
                    </Col>
                    </Row>),
                    (this.state.productToSwap === item.productCode ? 
                    <div  key = {item.productName} className ="product-details">
                        {/* <Row>
                            <Col>
                                <Form.Check 
                                                key ={item.productName}
                                                type="checkbox"
                                                defaultValue= {false}
                                                label= "Need us to service a specific cart? Select the serial number of the specific cart you would like serviced."
                                                checked={this.state.showSerialNumberCheck}
                                                onChange = {(event) => this.onShowSerialNumberCheck(event)}
                                                name= "check-available-product"/>
                            </Col>
                        </Row> */}


                                {/* {this.state.showSerialNumberCheck ? 
                                                        // <Form.Control as="select" name="select-asset" key = {item.productName} className="select-down-arrow" onChange={(event)=>this.onAssetIdSelected(event)}>
                                //     {item.serialNumber.map(item => {
                                //     return <option key = {item.assetId} value={item.assetId}>{item.serialNumber}</option>
                                //     })}
                                // </Form.Control>
                                    */}

                                    {(item.serialNumber.length > 0 && !this.state.showSerialNumberCheck) ? 
                                        <Row className="serial-number-margin-top">
                                             <Col> 
                                                { item.serialNumber.forEach(item => {
                                                    options.push({value :item.assetId, name :item.serialNumber});
                                                })
                                                }
                                                   <AutoComplete className={(!this.state.valid && this.state.selectedProductId.length === 0)? "invalid-border": ""} isValid={this.state.valid} suggestions= {options} onAssetIdSelected ={this.onAssetIdSelected} disabled= {this.state.showSerialNumberCheck}></AutoComplete>

                                                    {/* <SelectSearch
                                                            options={options}
                                                            search
                                                            onChange={(event)=>this.onAssetIdSelected(event)}
                                                            emptyMessage="Not found"
                                                            value={this.state.selectedProductId}
                                                            disabled= {this.state.showSerialNumberCheck}
                                                            filterOptions={fuzzySearch}
                                                            placeholder="Select"
                                                    /> */}
                                            </Col> 
                                         </Row>  : null
                                    }
                              

                            {(item.serialNumber.length > 0) ? 
                                <Row className="serial-number-margin-top">
                                    <Col>
                                                <Form.Check 
                                                        key ={item.productName}
                                                        type="checkbox"
                                                        defaultValue= {false}
                                                        label= "Check this box if you get a 'no cart found' message. A text box will appear below. Please enter your serial number there."
                                                        checked={this.state.showSerialNumberCheck}
                                                        onChange = {(event) => this.onShowSerialNumberCheck(event)}
                                                        name= "check-available-product"/>
                                    </Col>
                                </Row>  : null
                             }
                                
                                 { (this.state.showSerialNumberCheck || item.serialNumber.length <= 0) ? 
                                     <Row className="serial-number-margin-top">
                                        <Col> 
                                            <Form.Control type="text" className={(!this.state.valid && this.state.manualSerialNumber.length === 0)? "invalid-border": ""} placeholder="Enter cart serial number here" onChange={(event)=>this.onManualSerialNumber(event)} value={this.state.manualSerialNumber}/> 
                                        </Col>
                                     </Row> : null
                                 }
                                 
                    </div> : null ) 
                ] : (item.productCount > 0) ?[ 
                    (<Row key = "row-product-list">
                     <Col>
                         <Form.Check 
                                 key ={item.productName}
                                 type="radio"
                                 label= {item.displayName}
                                 value = {item.productCode}
                                 checked={item.productCode === this.state.productToSwap}
                                 onChange={(event) => this.onSelectProduct(event)}
                                 name= "available-product"/>
                     </Col>
                     </Row>),
                     (this.state.productToSwap === item.productCode ? 
                     <div  key = {item.productName} className ="product-details">
                                     {(item.serialNumber.length > 0) ? 
                                         <Row className="serial-number-margin-top">
                                              <Col> 
                                                 { item.serialNumber.forEach(item => {
                                                     options.push({value :item.assetId, name :item.serialNumber});
                                                 })
                                                 }
                                                      <SelectSearch
                                                             options={options}
                                                             search
                                                             onChange={(event)=>this.onAssetIdSelected(event)}
                                                             onFocus ={(event)=>this.onAssetIdSelected(event)}
                                                             emptyMessage="No cart found"
                                                             value={this.state.selectedProductId}
                                                             className={(!this.state.valid && this.state.selectedProductId.length === 0)? "select-search invalid-border": "select-search"}
                                                             filterOptions={fuzzySearch}
                                                             placeholder="Select"
                                                     />  
                                                       {/* <AutoComplete suggestions= {options} onAssetIdSelected ={this.onAssetIdSelected}></AutoComplete> */}
                                             </Col> 
                                          </Row>  : null
                                     }
                                  
                     </div> : null ) 
                 ] : null
            ]
                  
            }
            
        </div>
      ));

      var errorMessage = "";
      if(this.state.errorMessage.length > 0) {
        errorMessage = (<Row className="serial-number-margin-top">
            <Col className="error-text">
                {this.state.errorMessage}
            </Col>
        </Row>);
      }


      return(

          <div>
                {products}
                {errorMessage}
          </div>
        
                
      );
      
    }
}

export default CurrentProduct;